import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { validJobId } from '../helpers/helpers';
export const jobIdFormatGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const jobId = route.paramMap.get('jobId');
  const NO_JOB_ID_ROUTE = router.createUrlTree(['/no-job-id']);
  
  if (!validJobId(jobId)) {
    return NO_JOB_ID_ROUTE;
  }
  return true;
};
